<script setup>
import { ref, computed } from 'vue'
import { useUserStore } from '@/stores/user'
import ProfileForm from './ProfileForm.vue'
import {Button} from "@/components/ui/button"
import {Avatar, AvatarImage} from "@/components/ui/avatar"

import { readAndCompressImage } from 'browser-image-resizer'
import { useToast } from '@/components/ui/toast/use-toast'

const { toast } = useToast()

const userStore = useUserStore()
const member = computed(() => userStore.member)

const fileInput = ref(null)

const updateAvatar = async () => {
  const file = fileInput.value.files[0]
  const resizeConfig = {
    quality: 0.8,
    maxWidth: 400,
    maxHeight: 400,
    debug: true
  }
  const resizedFile = await readAndCompressImage(file, resizeConfig)
  const fileSize = resizedFile.size / 1024 / 1024

  if (fileSize > 1) {
    toast({ title: 'File size must be less than 1MB', variant: 'destructive' })
    return
  }

  await userStore.updateAvatar({
    file: resizedFile
  })
}
</script>

<template>
  <div class="pb-2">
    <div v-if="member" class="p-3">
      <div class="flex flex-col mb-4">
        <div class="mb-2">
          <Avatar class="w-28 h-28 cursor-pointer hover:opacity-80">
            <AvatarImage :src="member.avatar_url" :alt="member.display_name" />
          </Avatar>
        </div>
        <Button variant="secondary" size="sm" @click="fileInput.click()">Change avatar</Button>
        <div class="max-w-[250px]">
          <input ref="fileInput" type="file" style="display: none;" accept="image/jpeg, image/png" @change="updateAvatar">
        </div>
      </div>
      <div>
        <ProfileForm v-if="member.member_id" :member="member" />
      </div>
    </div>
  </div>
</template>
